/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyRubel = createReactComponent("outline", "currency-rubel", "IconCurrencyRubel", [["path", { "d": "M8 19v-14h6a3 3 0 0 1 0 6h-8", "key": "svg-0" }], ["path", { "d": "M14 15h-8", "key": "svg-1" }]]);

export { IconCurrencyRubel as default };
//# sourceMappingURL=IconCurrencyRubel.mjs.map
